export const PAGE_QUERY_STRING = "page";
export const LIMIT_QUERY_STRING = "limit";
